import BrandFreeAreaService from '@/services/free-area/brand-free-area'
import HostFreeAreaService from '@/services/free-area/host-free-area'

const freeAreaPaths = [
  'OrderCompleteFreeArea',
]
class OrderCompleteFreeAreaForBrandService extends BrandFreeAreaService {
  protected readonly freeAreaPaths = freeAreaPaths
}
class OrderCompleteFreeAreaForHostService extends HostFreeAreaService {
  protected readonly freeAreaPaths = freeAreaPaths
}
export default class OrderCompleteFreeAreaService {
  static readonly forBrand = OrderCompleteFreeAreaForBrandService
  static readonly forHost = OrderCompleteFreeAreaForHostService
}
